import { render, staticRenderFns } from "./HomeH5.vue?vue&type=template&id=50f69542&scoped=true"
import script from "./HomeH5.vue?vue&type=script&lang=js"
export * from "./HomeH5.vue?vue&type=script&lang=js"
import style0 from "./HomeH5.vue?vue&type=style&index=0&id=50f69542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f69542",
  null
  
)

export default component.exports